module.exports = __webpack_public_path__ + "img/1554436397.9f51cef4.jpg";